import {Controller} from "@/controllers/Controller";

// Sans groupId : le professionnel lui-même. Avec groupId : un comptable, sur l'un de ses professionnels.
const url = (resource, groupId, urlParams) =>
    `/business/accounting${groupId ? `/accountant/${groupId}` : ''}/${resource}${urlParams}`;

/**
 * Controller for accounting API : invoices, collections, purchases and disbursements tables / resumes, and accounting export
 */
export class AccountingController extends Controller {

    static getInvoiceTable(urlParams, groupId) {
        return this.requestBuilder("GET", url('invoices', groupId, urlParams), true);
    }

    static getInvoiceResume(urlParams, groupId) {
        return this.requestBuilder("GET", url('invoices/resume', groupId, urlParams), true);
    }

    static getCollectionTable(urlParams, groupId) {
        return this.requestBuilder("GET", url('collections', groupId, urlParams), true);
    }

    static getCollectionResume(urlParams, groupId) {
        return this.requestBuilder("GET", url('collections/resume', groupId, urlParams), true);
    }

    // Achats et décaissements : lus dans ms-purchase par l'espace comptabilité (le comptable y a aussi accès)
    static getPurchaseTable(urlParams, groupId) {
        return this.requestBuilder("GET", url('purchases', groupId, urlParams), true);
    }

    static getPurchaseResume(urlParams, groupId) {
        return this.requestBuilder("GET", url('purchases/resume', groupId, urlParams), true);
    }

    static getDisbursementTable(urlParams, groupId) {
        return this.requestBuilder("GET", url('disbursements', groupId, urlParams), true);
    }

    static getDisbursementResume(urlParams, groupId) {
        return this.requestBuilder("GET", url('disbursements/resume', groupId, urlParams), true);
    }

    static getExport(urlParams, groupId) {
        return this.requestBuilder("GET", url('export', groupId, urlParams), true);
    }

}
